import { useQuery } from "@tanstack/react-query";
export const createNamespacesQueries = (requests, queryClient) => ({
    useListNamespaces: (params, options = {}) => useQuery({
        queryKey: ["namespaces", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listNamespaces(params);
        },
        ...options,
    }),
});
//# sourceMappingURL=index.js.map